import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wall-image-item"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tag" }, "New", -1)
const _hoisted_3 = { class: "min-h-10 flex flex-col pt-[10px] gap-1 pb-[40px] sm:pb-[60px]" }
const _hoisted_4 = { class: "item__product-name" }
const _hoisted_5 = { class: "item__brand" }
const _hoisted_6 = { class: "flex leading-[20px] tracking-[.1em] text-xs items-center text-light-gary-text-color underline" }
const _hoisted_7 = { class: "item__portfolio-name" }
const _hoisted_8 = { class: "item__icon flex justify-between px-2 sm:px-7" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_EditInput = _resolveComponent("EditInput")!
  const _component_under_line = _resolveComponent("under-line")!

  return (_ctx.portfolioRef)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: "g-image-component",
          style: _normalizeStyle({
        backgroundImage:
          'url(' + _ctx.portfolioRef.Thumbnail + '?' + Date.now() + ')',
      })
        }, null, 4),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.portfolioRef.CmdyName || ""), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.portfolioRef.CmdySubName || ""), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.portfolioRef.EditorPartnerBookId), 1),
            _createVNode(_component_Icon, {
              class: "cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCopy(_ctx.portfolioRef.EditorPartnerBookId))),
              onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCopy(_ctx.portfolioRef.EditorPartnerBookId))),
              iconName: "copy3",
              width: '20px'
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_EditInput, {
              portfolio: _ctx.portfolioRef,
              "onUpdate:portfolio": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.portfolioRef) = $event)),
              modelValue: _ctx.portfolioRef.Name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.portfolioRef.Name) = $event)),
              onEditPortfolioName: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editPortfolioNameRef(_ctx.portfolioRef)))
            }, null, 8, ["portfolio", "modelValue"])
          ]),
          _createVNode(_component_under_line, { class: "m-[unset]" }),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", {
              title: '刪除',
              class: "cursor-pointer",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.delPortfolio(_ctx.portfolioRef)))
            }, [
              _createVNode(_component_Icon, {
                width: '24px',
                iconName: "garbage-can"
              })
            ]),
            _createElementVNode("span", {
              title: '複製',
              class: _normalizeClass([_ctx.portfolioRef.CanEdit ? 'cursor-pointer' : 'cursor-not-allowed']),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.copyPortfolio(_ctx.portfolioRef)))
            }, [
              _createVNode(_component_Icon, {
                width: '24px',
                iconName: "copy"
              })
            ], 2),
            _createElementVNode("span", {
              title: '編輯',
              class: _normalizeClass(["cursor-pointer", [_ctx.portfolioRef.CanEdit ? 'cursor-pointer' : 'cursor-not-allowed']]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.continueEdit(_ctx.portfolioRef)))
            }, [
              _createVNode(_component_Icon, {
                width: '24px',
                iconName: "pencil"
              })
            ], 2),
            _createElementVNode("span", {
              title: '加入購物車',
              class: _normalizeClass(["cursor-pointer", [_ctx.portfolioRef.CanAddCart ? 'cursor-pointer' : 'cursor-not-allowed']]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addShoppingCart(_ctx.portfolioRef)))
            }, [
              _createVNode(_component_Icon, {
                width: '24px',
                iconName: "bag-dark"
              })
            ], 2)
          ])
        ]),
        _hoisted_9
      ]))
    : _createCommentVNode("", true)
}